import "./FormInfo.less";
import IntlMessages from "../../../../util/IntlMessages";

const FormInfo = ({ selectedForm }) => {
   if (!selectedForm.value) return;

   const [module, name] = selectedForm?.value?.split("-");
   return (
      <ul className="form-builder-info">
         <li>
            <IntlMessages id="modal.formModelName" /> : <strong>{name}</strong>
         </li>
         <li>
            <IntlMessages id="modal.formModelModule" /> : <strong>{module}</strong>
         </li>
      </ul>
   );
};

export default FormInfo;
